import { combineReducers } from "redux";
import LayoutReducer from "./layouts/reducer";
import AdminReducer from "./admin/adminSlice";
import BuilderReducer from "./builder/builderSlice";
import InspectorReducer from "./inspector/inspectorSlice";
import UserSlice from "./user/userSlice";

const rootReducer = combineReducers({
    Layout:LayoutReducer,
    Admin:AdminReducer,
    Builder:BuilderReducer,
    Inspector:InspectorReducer,
    User:UserSlice,
})

export default rootReducer;